<template>
    <VListItemTitle v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemTitle>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-title';

export default {
    name: 'SrListItemTitle',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
